import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as StatisticActions from '../../actions/statisticActions';

class StatsButton extends Component {

    onStatsControlButtonClick(){
      if(this.props.statisticWindows.statsSelectorVisible)
        this.props.StatisticActions.close_stats_selector();
      else
        this.props.StatisticActions.show_stats_selector();
    }

    render() {
        return (<i id="statsButton" className="fa fa-window-maximize" role="button" aria-hidden="true" onClick={this.onStatsControlButtonClick.bind(this)}>
                </i>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        statisticWindows: state.statisticWindows
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(StatsButton)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/StatsButton.js
 **/